// extracted by mini-css-extract-plugin
export default {"wrapper":"W3-z","play":"X3-z"};